module.exports = __webpack_public_path__ + "img/energetyka-24.b3d13655.svg";